import { Component, ChangeDetectionStrategy, Input } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import {
  NgxExtendedPdfViewerService,
  pdfDefaultOptions,
} from 'ngx-extended-pdf-viewer'
import { CareFinitySession } from '../carefinity/services/CareFinitySession'
import { DocumentService } from '../api/services'

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfViewerComponent {
    @Input()
    pdf: Blob
    @Input()
    showPrintButton: boolean=false
  @Input()
    enabledDocumentDownloads: boolean=false
  /** In most cases, you don't need the NgxExtendedPdfViewerService. It allows you
   *  to use the "find" api, to extract text and images from a PDF file,
   *  to print programmatically, and to show or hide layers by a method call.
   */
    constructor(
        private router: Router, private activatedRoute: ActivatedRoute,
        private docService: DocumentService,

    private pdfService: NgxExtendedPdfViewerService,
    ) {



        this.activatedRoute.queryParamMap.subscribe(param => {

            if(param.get('document'))
            this.viewDoc(param.get('document'), "false");

        })
    /* More likely than not you don't need to tweak the pdfDefaultOptions.
       They are a collecton of less frequently used options.
       To illustrate how they're used, here are two example settings: */
    pdfDefaultOptions.doubleTapZoomFactor = '150%' // The default value is '200%'
    pdfDefaultOptions.maxCanvasPixels = 1000 * 1000 * 5 // The default value is 4096 * 4096 pixels,
    // but most devices support much higher resolutions.
    // Increasing this setting allows your users to use higher zoom factors,
        // trading image quality for performance.
        console.log("state is",this.router.getCurrentNavigation())

    this.pdf = this.router.getCurrentNavigation()?.extras.state.pdf
    //this.showPrintButton =
      //  this.router.getCurrentNavigation()?.extras.state.showPrintButton

      this.showPrintButton = !!this.router.getCurrentNavigation()?.extras.state.showPrintButton;
        this.enabledDocumentDownloads = !!this.router.getCurrentNavigation()?.extras.state.enabledDocumentDownloads;
      //if (CareFinitySession?.user?.roles?.patientRecordsPrint) {


      //}
    }

    viewDoc(docName:string,flexPaper:string) {


   
  
                    this.docService
                        .documentGetDocuments({
                            fn: docName,
                            PatientName: sessionStorage.getItem('ptName'),
                        })
                        .subscribe((file) => {
                       
                                const binaryData = [file]
                                const downloadLink = document.createElement('a')
                                downloadLink.href = window.URL.createObjectURL(
                                    new Blob(binaryData, { type: file.type }),
                                )
                                downloadLink.target = '_blank'
                                downloadLink.setAttribute('inline', 'arshid')
                                document.body.appendChild(downloadLink)
                                downloadLink.click()
                                document.body.removeChild(downloadLink) // Clean up

                            
                        })
           
        
    }

}
